/**
 * @generated
 * This file is generated by scripts/generate-async-query-metadata.js.
 * Do not edit manually.
 * Source: src/ui/search-page-relay/right-panel/__generated__/rightPanelAsyncQuery.graphql.ts
 */

export const RIGHT_PANEL_ASYNC_QUERY_PERSISTED_ID =
	'a57fdf0013c653c1e776cfee7d150d3bf49b57272c69d4e21ac72411b7dd6184';
export const RIGHT_PANEL_ASYNC_QUERY_OPERATION_NAME = 'rightPanelAsyncQuery';
